<div
  class="palantir-select-item-overlay"
  [style.width]="data.width || '300px'"
  [style.height]="data.height || '300px'"
>
  <div
    class="palantir-select-item-overlay__content"
    #content
    [class.is-scrolling]="isScrolling()"
    cdkVirtualScrollingElement
  >
    <palantir-input [control]="searchControl" prefix="search-outline">
      <input type="text" [placeholder]="data.searchPlaceholderText" [formControl]="searchControl" />
    </palantir-input>

    @if (data.type === 'multiple' && items().length) {
      <div class="palantir-select-item-overlay__select-all">
        <palantir-checkbox
          [label]="data.selectAllText"
          invert="true"
          [attr.aria-selected]="isAllSelected()"
          [attr.indeterminate]="model.hasValue() && !isAllSelected()"
          (click)="toggleAll()"
        />
      </div>
    }

    <palantir-content class="palantir-select-item-overlay__items palantir-scrollbar">
      @if (items().length || isLoading()) {
        <cdk-virtual-scroll-viewport autosize class="palantir-select-item-overlay__scroll-viewport">
          <palantir-selectable-item-overlay
            *cdkVirtualFor="let item of items(); trackBy: trackByFn"
            [item]="item"
            [items]="allItems()"
            [model]="model"
            [type]="data.type"
            [limitItems]="limitItems()"
          />

          @if (isLoading()) {
            @for (_ of [].constructor(3); track $index) {
              <div class="palantir-select-item-overlay__skeleton-item">
                <palantir-skeleton class="palantir-select-item-overlay__skeleton-avatar" />
                <div class="palantir-select-item-overlay__skeleton-content">
                  <palantir-skeleton class="palantir-select-item-overlay__skeleton-title" />
                  <palantir-skeleton class="palantir-select-item-overlay__skeleton-subtitle" />
                </div>
              </div>
            }
          }
        </cdk-virtual-scroll-viewport>
      }

      @if (!items().length && !isLoading()) {
        <palantir-text class="palantir-select-item-overlay__empty" type="description">{{
          data.emptyText
        }}</palantir-text>
      }
    </palantir-content>
  </div>
</div>
